import React from "react";
import { connect } from "react-redux";
import { searchFindingAids } from "../../actions/searchFindingAids";
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

function OtherInformation(props) {
  return (
    <AccordionItem uuid="other-information" className="summary card">
      <AccordionItemHeading className="card-header">
        <AccordionItemButton>
          <a name={props.name}>
            <p className="card-title accordion-headers">Other Information</p>
          </a>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel className="card-body">
        <div className="card-text">
          {Object.keys(props.list).map((item, i) => (
            <div key={i}>
              {item.includes("</strong>") ? (
                <p
                  tabIndex="0"
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                ></p>
              ) : (
                <p
                  className="label"
                  tabIndex="0"
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                ></p>
              )}
              <p
                className="text "
                tabIndex="0"
                dangerouslySetInnerHTML={{
                  __html: " " + props.list[item],
                }}
              ></p>
            </div>
          ))}
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
}

const mapStateToProps = (state) => ({
  findingAid: state.findingAids.findingAids,
});

export default connect(mapStateToProps, { searchFindingAids })(
  OtherInformation
);
